export enum WorkEffortLevels {
  /**
   * Oficina
   */
  None = 0.3,
  /**
   * Trabajo físico ligero
   */
  Light = 0.5,
  /**
   * Trabajo físico medio
   */
  Intermediate = 0.6,
  /**
   * Trabajo fisico elevado
   */
  High = 0.7,
}
